var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "projectCreateProjectModal",
        size: "md",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("message.create_project"),
      },
      on: {
        hide: function ($event) {
          return _vm.resetValues()
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.createProject()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.create")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "b-tabs",
        {
          staticClass: "body-bg-color",
          staticStyle: { border: "0", padding: "0" },
        },
        [
          _c(
            "b-tab",
            {
              staticClass: "body-bg-color",
              staticStyle: { border: "0", padding: "0" },
              attrs: { active: "" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-edit" }),
                      _vm._v(" " + _vm._s(_vm.$t("message.general"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "project-name-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      lazy: "true",
                      required: "true",
                      feedback: "true",
                      autofocus: "false",
                      label: _vm.$t("message.project_name"),
                      tooltip: this.$t("message.project_name_desc"),
                      "feedback-text": _vm.$t("message.required_project_name"),
                    },
                    model: {
                      value: _vm.project.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.project, "name", $$v)
                      },
                      expression: "project.name",
                    },
                  }),
                  _c(
                    "b-row",
                    { attrs: { "align-v": "stretch" } },
                    [
                      _c(
                        "b-col",
                        [
                          _c("b-input-group-form-input", {
                            attrs: {
                              id: "project-version-input",
                              "input-group-size": "mb-3",
                              type: "text",
                              lazy: "true",
                              required: "false",
                              feedback: "false",
                              autofocus: "false",
                              label: _vm.$t("message.version"),
                              tooltip: this.$t(
                                "message.component_version_desc"
                              ),
                            },
                            model: {
                              value: _vm.project.version,
                              callback: function ($$v) {
                                _vm.$set(_vm.project, "version", $$v)
                              },
                              expression: "project.version",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c("b-input-group-form-switch", {
                            attrs: {
                              id: "project-create-islatest",
                              label: _vm.$t("message.project_is_latest"),
                              "show-placeholder-label": true,
                            },
                            model: {
                              value: _vm.project.isLatest,
                              callback: function ($$v) {
                                _vm.$set(_vm.project, "isLatest", $$v)
                              },
                              expression: "project.isLatest",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("b-input-group-form-select", {
                    attrs: {
                      id: "v-classifier-input",
                      required: "true",
                      options: _vm.sortAvailableClassifiers,
                      label: _vm.$t("message.classifier"),
                      tooltip: _vm.$t("message.component_classifier_desc"),
                    },
                    model: {
                      value: _vm.project.classifier,
                      callback: function ($$v) {
                        _vm.$set(_vm.project, "classifier", $$v)
                      },
                      expression: "project.classifier",
                    },
                  }),
                  _c("b-input-group-form-select", {
                    attrs: {
                      id: "v-team-input",
                      required: _vm.requiresTeam,
                      options: _vm.availableTeams,
                      label: _vm.$t("message.team"),
                      tooltip: _vm.$t("message.component_team_desc"),
                      disabled: _vm.isDisabled,
                    },
                    model: {
                      value: _vm.project.team,
                      callback: function ($$v) {
                        _vm.$set(_vm.project, "team", $$v)
                      },
                      expression: "project.team",
                    },
                  }),
                  _c("b-input-group-form-select", {
                    attrs: {
                      id: "v-collection-logic-input",
                      required: "true",
                      options: _vm.availableCollectionLogics,
                      label: _vm.$t("message.collectionLogic"),
                      tooltip: _vm.$t("message.project_collection_logic_desc"),
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    on: { change: _vm.syncCollectionTagsVisibility },
                    model: {
                      value: _vm.project.collectionLogic,
                      callback: function ($$v) {
                        _vm.$set(_vm.project, "collectionLogic", $$v)
                      },
                      expression: "project.collectionLogic",
                    },
                  }),
                  _c("vue-tags-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showCollectionTags,
                        expression: "showCollectionTags",
                      },
                    ],
                    staticClass: "mw-100 bg-transparent text-lowercase",
                    attrs: {
                      id: "input-collectionTags",
                      tags: _vm.collectionTags,
                      "add-on-key": _vm.addOnKeys,
                      placeholder: _vm.$t("message.project_add_collection_tag"),
                      "autocomplete-items": _vm.tagsAutoCompleteItems,
                      "max-tags": 1,
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    on: {
                      "tags-changed": (newCollectionTags) =>
                        (this.collectionTags = newCollectionTags),
                    },
                    model: {
                      value: _vm.collectionTagTyping,
                      callback: function ($$v) {
                        _vm.collectionTagTyping = $$v
                      },
                      expression: "collectionTagTyping",
                    },
                  }),
                  _c(
                    "div",
                    { staticStyle: { "margin-bottom": "1rem" } },
                    [
                      _c("label", [_vm._v("Parent")]),
                      _c("multiselect", {
                        attrs: {
                          id: "multiselect",
                          "custom-label": _vm.createProjectLabel,
                          placeholder: this.$t("message.search_parent"),
                          "open-direction": "bottom",
                          options: _vm.availableParents,
                          multiple: false,
                          searchable: true,
                          "track-by": "uuid",
                          loading: _vm.isLoading,
                          "internal-search": false,
                          "close-on-select": true,
                          selectLabel: "",
                          deselectLabel: "",
                        },
                        on: { "search-change": _vm.asyncFind },
                        model: {
                          value: _vm.selectedParent,
                          callback: function ($$v) {
                            _vm.selectedParent = $$v
                          },
                          expression: "selectedParent",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "project-description-form-group",
                        label: this.$t("message.description"),
                        "label-for": "project-description-input",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          id: "project-description-description",
                          rows: "3",
                        },
                        model: {
                          value: _vm.project.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.project, "description", $$v)
                          },
                          expression: "project.description",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "project-classifier-form-group",
                        label: this.$t("message.tags"),
                        "label-for": "input-4",
                      },
                    },
                    [
                      _c("vue-tags-input", {
                        staticClass: "mw-100 bg-transparent text-lowercase",
                        attrs: {
                          id: "input-4",
                          tags: _vm.tags,
                          "add-on-key": _vm.addOnKeys,
                          placeholder: _vm.$t("message.add_tag"),
                          "autocomplete-items": _vm.tagsAutoCompleteItems,
                        },
                        on: {
                          "tags-changed": (newTags) => (this.tags = newTags),
                        },
                        model: {
                          value: _vm.tag,
                          callback: function ($$v) {
                            _vm.tag = $$v
                          },
                          expression: "tag",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tab",
            {
              staticClass: "body-bg-color",
              staticStyle: { border: "0", padding: "0" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-cube" }),
                      _vm._v(" " + _vm._s(_vm.$t("message.identity"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "project-name-input-identify",
                      "input-group-size": "mb-3",
                      type: "text",
                      lazy: "true",
                      required: "false",
                      feedback: "true",
                      autofocus: "false",
                      disabled: "true",
                      label: _vm.$t("message.project_name"),
                      tooltip: this.$t("message.project_name_desc"),
                      readonly: true,
                    },
                    model: {
                      value: _vm.readOnlyProjectName,
                      callback: function ($$v) {
                        _vm.readOnlyProjectName = $$v
                      },
                      expression: "readOnlyProjectName",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "project-version-input-identify",
                      "input-group-size": "mb-3",
                      type: "text",
                      lazy: "true",
                      required: "false",
                      feedback: "true",
                      autofocus: "false",
                      disabled: "true",
                      label: _vm.$t("message.version"),
                      tooltip: this.$t("message.component_version_desc"),
                      readonly: true,
                    },
                    model: {
                      value: _vm.readOnlyProjectVersion,
                      callback: function ($$v) {
                        _vm.readOnlyProjectVersion = $$v
                      },
                      expression: "readOnlyProjectVersion",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "project-group-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("message.component_namespace_group_vendor"),
                      tooltip: this.$t("message.component_group_desc"),
                    },
                    model: {
                      value: _vm.project.group,
                      callback: function ($$v) {
                        _vm.$set(_vm.project, "group", $$v)
                      },
                      expression: "project.group",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "project-purl-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("message.package_url_full"),
                      tooltip: this.$t("message.component_package_url_desc"),
                    },
                    model: {
                      value: _vm.project.purl,
                      callback: function ($$v) {
                        _vm.$set(_vm.project, "purl", $$v)
                      },
                      expression: "project.purl",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "project-cpe-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("message.cpe_full"),
                      tooltip: _vm.$t("message.component_cpe_desc"),
                    },
                    model: {
                      value: _vm.project.cpe,
                      callback: function ($$v) {
                        _vm.$set(_vm.project, "cpe", $$v)
                      },
                      expression: "project.cpe",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "project-swidTagId-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("message.swid_tagid"),
                      tooltip: _vm.$t("message.component_swid_tagid_desc"),
                    },
                    model: {
                      value: _vm.project.swidTagId,
                      callback: function ($$v) {
                        _vm.$set(_vm.project, "swidTagId", $$v)
                      },
                      expression: "project.swidTagId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }